import React, { useEffect, useState } from 'react';
import './estilodashuser.css';
import api from '../api';

export default function Downloads() {
  const [arquivos, setArquivos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchArquivos = async () => {
      try {
        setLoading(true);
        const response = await api.get('/api/arquivos');
        setArquivos(response.data || []);
      } catch (error) {
        console.error('Erro ao listar arquivos para download:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchArquivos();
  }, []);

  return (
    <div className="content-page">
      <div className="content-card">
        <div className="content-page-header">
          <div>
            <h2>Downloads</h2>
            <p>
              Aqui você encontra robôs, templates, manuais e arquivos necessários para instalação e operação.
            </p>
          </div>
        </div>

        <div className="cliente-help-box" style={{ marginBottom: 14 }}>
          <strong>Dica:</strong> baixe primeiro o robô principal e depois os arquivos de apoio. Se tiver dúvida na instalação,
          consulte o manual correspondente e, se necessário, fale com o suporte.
        </div>

        {loading && <p className="lic-loading">Carregando arquivos...</p>}

        {!loading && arquivos.length === 0 && (
          <div className="cliente-empty-box">Nenhum arquivo disponível no momento.</div>
        )}

        {!loading && arquivos.length > 0 && (
          <div className="download-grid">
            {arquivos.map((nome, index) => (
              <a
                key={index}
                href={`https://quantumtrades.com.br:8080/downloads/${nome}`}
                download
                className="download-card"
              >
                <div className="download-icon">📦</div>
                <div className="download-name">{nome}</div>
                <div className="download-action">Clique para baixar</div>
              </a>
            ))}
          </div>
        )}

        <div className="legal-box">
          <strong>Observação importante</strong>
          <p>
            Os setups, parâmetros e arquivos compartilhados nesta área não são de responsabilidade da <strong>Quantum Trades</strong>.
            A utilização destes materiais é de inteira responsabilidade do usuário, sendo feita por sua conta e risco.
          </p>
          <p>
            Resultados exibidos em backtests, demonstrações, portfólios e simulações são apenas estimativas e não representam
            garantia de desempenho futuro.
          </p>
          <p>
            É proibida a distribuição, cópia, venda, compartilhamento ou uso do robô em qualquer sistema de terceiros sem autorização expressa.
          </p>
        </div>
      </div>
    </div>
  );
}
